import React, { useContext, useEffect, useState } from 'react'
import styles from '../styles.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { StaffRosterContext } from '../../../../utils/context'
import { getPersonCourses, deletePersonCourses } from '../../../../actions/personnel/personnel'
import Table from '../../../../components/Table'
import Confirmation from '../../../../components/Confirmation/Confirmation'
import { BiTrash } from 'react-icons/bi'
import Button from '../../../../components/Button'
import ModalLesson from './ModalLesson'

export default function Lessons() {

  const dispatch = useDispatch()

  const { allForms, addMode, mid } = useContext(StaffRosterContext)
  const { personTabData } = useSelector(state => state.personnel)
  const { lesson: apiLesson } = personTabData || {}

  const { values } = allForms

  const [confirmation, setConfirmation] = useState(false);
  const [openModalLessons, setOpenModalLessons] = useState(false);

  useEffect(() => {
    if (mid && !addMode) {
      dispatch(getPersonCourses(mid))
    }
  }, [mid, addMode, dispatch])

  const acceptConfirmation = async () => {
    if (confirmation?.cid && mid) {
      await dispatch(deletePersonCourses(mid, [confirmation.cid]))
    }
    setConfirmation(false);
  };

  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderRow = (row) => {
    const { title, cid, pid } = row
    const courseId = cid || pid
    return (
      <tr key={courseId}>
        <td>{title}</td>
        <td>
          <i className={styles.trash} onClick={() => setConfirmation({ cid: courseId, name: title })}>
            <BiTrash />
          </i>
        </td>
      </tr>
    )
  }

  const openModalLesson = () => {
    setOpenModalLessons(true)
  }

  const closeModalLesons = () => {
    setOpenModalLessons(false)
  }

  return (
    <div className={styles.tabWrapper}>
      {openModalLessons &&
        <ModalLesson
          openModalLessons={openModalLessons}
          setOpenModalLessons={setOpenModalLessons}
          closeModalLesons={closeModalLesons}
          mid={mid}
        />
      }

      {/* Таблица */}
      <div className={styles.qualificationTableSection}>
        <Table>
          {confirmation && (
            <Confirmation
              top="30px"
              left="40px"
              title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
              acceptConfirmation={acceptConfirmation}
              rejectConfirmation={rejectConfirmation}
            />
          )}
          <thead>
            <tr>
              <th>Название</th>
              <th>Удалить</th>
            </tr>
          </thead>
          <tbody>
            {apiLesson?.length > 0 ? (
              apiLesson.map(renderRow)
            ) : (
              <tr>
                <td colSpan="2" className={styles.emptyTable}>
                  Нет данных о предметах
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Кнопки */}
      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <div className={styles.qualificationButtonsInline}>
            <Button onClick={openModalLesson}>+ Добавить</Button>
          </div>
        </div>
      </div>
    </div>
  )
}
